import React from "react";
import { Link } from "gatsby";
import heroArt from "../../assets/img/hero-editorial.svg";

/**
 * Primer impacto de la home pública. `heroArt` es la composición editorial del
 * piloto: para usar una foto real alcanza con cambiar el import.
 */
const Hero = () => (
	<section id="inicio" className="anchor-target bg-paper py-10 lg:py-[42px] lg:pb-[54px]">
		<div className="shell grid items-stretch gap-8 lg:grid-cols-[minmax(0,.91fr)_minmax(0,1.09fr)] lg:gap-12 xl:gap-16">
			<div className="flex flex-col items-start justify-center lg:py-8">
				<p className="eyebrow">Belimport · Uruguay</p>

				<h1 className="display-1 my-5 max-w-[720px] lg:mb-7 lg:mt-5">
					Marcas para la belleza profesional.
				</h1>

				<p className="mb-5 max-w-[590px] text-[17px] leading-relaxed tracking-[-.018em] text-ink-soft lg:text-xl">
					Importamos y comercializamos marcas e insumos para las principales áreas de la belleza profesional.
				</p>

				<p className="mb-7 max-w-[630px] text-[9px] font-semibold uppercase leading-relaxed tracking-[.07em] text-muted lg:mb-8 lg:text-[11px]">
					Coloración · Cuidado capilar · Uñas · Depilación · Herramientas · Mobiliario
				</p>

				<div className="flex w-full flex-col items-stretch gap-2.5 sm:w-auto sm:flex-row sm:items-center">
					<Link className="button button--primary" to="/#marcas">
						Conocer las marcas <span aria-hidden="true">→</span>
					</Link>
					<Link className="button button--quiet" to="/#promociones">
						Ver promociones
					</Link>
				</div>
			</div>

			<figure className="m-0 min-h-[330px] overflow-hidden bg-ink shadow-editorial sm:min-h-[365px] lg:min-h-[576px]">
				<img
					src={ heroArt }
					alt="Composición editorial inspirada en coloración y cuidado capilar, con Hidracolor y Küül como marcas destacadas"
					className="h-full w-full object-cover"
				/>
			</figure>
		</div>
	</section>
);

export default Hero;
